import { Pipe, PipeTransform } from '@angular/core';
import { SlicePipe } from '@angular/common';

@Pipe({
    name: 'shortText',
    standalone: false
})
export class ShortTextPipe implements PipeTransform {
	private slicePipe: SlicePipe;

	constructor() {
		this.slicePipe = new SlicePipe();
	}

	transform(value: string, limit: number = 25): string {
		if (value && value.length > limit) {
			return this.slicePipe.transform(value, 0, limit) + '...';
		}
		return value;
	}

}
